// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__5Sqb+","scrolled-offset":"Hero_scrolled-offset__77Z+P","hero__desc":"Hero_hero__desc__YLxor"};